(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ata-care-consent"] && !Shopify.designMode) return;
  try {
    if (!window.ataCareConsentReady) {
    window.ataCareConsentReady = true;

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-ata-care-consent-close]');

      if (closeButton) {
        closeButton.closest('dialog').close();
        return;
      }

      const checkoutButton = event.target.closest('[name="checkout"]');

      if (!checkoutButton) return;

      const consent = document.querySelector('[data-ata-care-consent]');
      const checkbox = consent?.querySelector('[data-ata-care-consent-checkbox]');
      const valueInput = consent?.querySelector('[data-ata-care-consent-value]');
      const dialog = consent?.querySelector('[data-ata-care-consent-dialog]');

      if (!checkbox) return;

      if (!checkbox.checked) {
        event.preventDefault();
        dialog.showModal();
        return;
      }

      if (!valueInput.value) valueInput.value = new Date().toString();
    }, true);

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-ata-care-consent-checkbox]')) return;

      const consent = event.target.closest('[data-ata-care-consent]');
      const valueInput = consent.querySelector('[data-ata-care-consent-value]');

      valueInput.value = event.target.checked ? new Date().toString() : '';
    });
  }
  } catch(e) { console.error(e); }
})();

})();
